module.exports = __webpack_public_path__ + "img/virtual_tour.81ea7a6d.jpg";